export default "__VITE_PUBLIC_ASSET__77707ecf__"